var config = {
  isLocal: !(process.env.NEXT_PUBLIC_ENVIRONMENT === 'prod')
};
export default config;